import React, { useState } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Icon } from 'antd';
import { PLAN_DESCRIPTIONS } from 'constant';
import PropTypes from 'prop-types';

import Card from 'components/card/Card';
import DateLineItem from 'components/dateLineItem/DateLineItem';
import { ModalSto } from 'components/sto';

import PlanName from './PlanName';

const PlanCard = (props) => {
    const [modalVisibility, setModalVisibility] = useState(false);

    const hasPlanDescription = !!props.planDescriptionType && !!PLAN_DESCRIPTIONS[props.planDescriptionType];

    return (
        <Card aria-label={`plan ${props.planTitle}`}>
            <div className="card-line-item">
                <div className="plan-header">
                    <div>
                        <div className="plan-name-wrapper">
                            <h5 className="plan-name">
                                <PlanName planId={props.planId} planTitle={props.planTitle} />
                            </h5>
                            {hasPlanDescription && (
                                <button
                                    aria-live="polite"
                                    className="question-circle-button"
                                    onClick={() => setModalVisibility(true)}
                                    role="tooltip"
                                    tabIndex={0}
                                    type="button"
                                >
                                    <Icon className="popup-hint" id="info-icon" type="question-circle" />
                                </button>
                            )}
                        </div>
                        <p className="plan-id">
                            <FormattedMessage id="plan.details.plan.id" />
                            {props.planId}
                        </p>
                    </div>
                    <div>
                        <p className="balance-label">
                            <FormattedMessage id="plan.details.balance.owing" />
                        </p>
                        <p className="balance-value">
                            <FormattedNumber
                                currency="CAD"
                                currencyDisplay="narrowSymbol"
                                style="currency"
                                value={props.balanceOwing}
                            />
                        </p>
                    </div>
                    <div className="plan-item">
                        <p>
                            <FormattedMessage id="plan.details.minimum.payment" />
                        </p>
                        <p className="plan-item-value">
                            <FormattedNumber
                                currency="CAD"
                                currencyDisplay="narrowSymbol"
                                style="currency"
                                value={props.minimumPayment}
                            />
                        </p>
                    </div>
                </div>
            </div>
            <div className="card-line-item">
                <div className="plan-item">
                    <p>
                        <FormattedMessage id="plan.details.expiry.date" />
                    </p>
                    <p className="plan-item-value">
                        <DateLineItem value={props.expiryDate} />
                    </p>
                </div>
                <div className="plan-item">
                    <p>
                        <FormattedMessage id="plan.details.accrued.interest" />
                    </p>
                    <p className="plan-item-value">
                        <FormattedNumber
                            currency="CAD"
                            currencyDisplay="narrowSymbol"
                            style="currency"
                            value={props.accruedInterest}
                        />
                    </p>
                </div>
            </div>
            <ModalSto
                modalType="planDescription"
                okText="general.ok"
                onOk={() => setModalVisibility(false)}
                visible={modalVisibility}
                wrapClassName=""
            >
                <div className="plan-description">
                    <Icon className="popup-hint" id="info-icon" type="question-circle" />
                    <div className="plan-description-details">
                        <h3 className="plan-name">
                            <PlanName planId={props.planId} planTitle={props.planTitle} />
                        </h3>
                        <p className="plan-description-text">
                            <FormattedMessage id={PLAN_DESCRIPTIONS[props.planDescriptionType]} />
                        </p>
                    </div>
                </div>
            </ModalSto>
        </Card>
    );
};

PlanCard.propTypes = {
    accruedInterest: PropTypes.number.isRequired,
    balanceOwing: PropTypes.number.isRequired,
    expiryDate: PropTypes.string.isRequired,
    minimumPayment: PropTypes.number.isRequired,
    planDescriptionType: PropTypes.string.isRequired,
    planId: PropTypes.number.isRequired,
    planTitle: PropTypes.string.isRequired,
};

export default PlanCard;
